import NotFound from '@/pages/NotFound';
import { useFlag } from '@/features/unleash';
import useUser from '@/hooks/useUser';
import useNarrativeById from './hooks/useNarrativeById';
import { PublicNarrativeEdit } from './components/PublicNarrativeEdit';
import { getLocationPayload } from '@/redux/location/selectors';
import { useSelector } from 'react-redux';
import { NarrativeLayout } from './components/NarrativeLayout';

export const PublicNarrativeEditPage = () => {
  const payload = useSelector(getLocationPayload);
  const narrativeId = payload.id as string;

  const flag = useFlag({ name: 'mono-narrative-eu-author' });
  const { data: user } = useUser();
  const { data: narrative, status } = useNarrativeById(narrativeId);

  if (!user.loggedIn || !flag.enabled) {
    return <NotFound />;
  }

  return (
    <NarrativeLayout
      title="Edit Narrative"
      isLoading={status === 'pending' || !flag.flagsReady}
      error={status === 'error'}
    >
      {narrative && <PublicNarrativeEdit narrative={narrative} user={user} />}
    </NarrativeLayout>
  );
};
